import type { CookieReconcileResult } from '../utils/cookie-reconciliation';
import { parseCookieHeader, setCookieInHeader } from '../utils/cookie-utils';

export const AD_DEV_MODE_QUERY_PARAM = 'ad_dev_mode';
export const AD_DEV_MODE_QUERY_VALUE = 'true';
export const WAND_AD_DEV_MODE_COOKIE_NAME = 'wand_ad_dev_mode';
export const WAND_AD_DEV_MODE_COOKIE_VALUE = '1';

export function isAdPreviewRequested(searchParams: URLSearchParams): boolean {
    return searchParams.get(AD_DEV_MODE_QUERY_PARAM) === AD_DEV_MODE_QUERY_VALUE;
}

export function isAdPreviewMode(cookieHeader: string): boolean {
    return parseCookieHeader(cookieHeader).get(WAND_AD_DEV_MODE_COOKIE_NAME) === WAND_AD_DEV_MODE_COOKIE_VALUE;
}

function buildAdPreviewSetCookieHeader(isSecure: boolean): string {
    const parts = [`${WAND_AD_DEV_MODE_COOKIE_NAME}=${WAND_AD_DEV_MODE_COOKIE_VALUE}`, 'Path=/', 'SameSite=Lax'];

    if (isSecure) {
        parts.push('Secure');
    }

    return parts.join('; ');
}

export function reconcileAdPreviewCookieForRequest(
    request: Pick<Request, 'url'>,
    cookieHeader: string,
): CookieReconcileResult {
    const searchParams = new URL(request.url).searchParams;

    if (!isAdPreviewRequested(searchParams)) {
        return {
            downstreamCookieHeader: cookieHeader,
            setCookieHeaders: [],
        };
    }

    const downstreamCookieHeader = isAdPreviewMode(cookieHeader)
        ? cookieHeader
        : setCookieInHeader(cookieHeader, WAND_AD_DEV_MODE_COOKIE_NAME, WAND_AD_DEV_MODE_COOKIE_VALUE);

    const isSecure = new URL(request.url).protocol === 'https:';

    return {
        downstreamCookieHeader,
        setCookieHeaders: [buildAdPreviewSetCookieHeader(isSecure)],
    };
}

export async function reconcileAdPreviewCookiesForRequest(
    request: Pick<Request, 'url' | 'headers'>,
    cookieHeader: string,
    _wandWebsiteUrl: string,
): Promise<CookieReconcileResult> {
    return reconcileAdPreviewCookieForRequest(request, cookieHeader);
}
